/**
 * DomainAvailabilityIndicator — FE-W-05.
 *
 * useDomainAvailability hook 결과를 시각화. a11y aria-live="polite".
 * 색맹 친화: status 별 아이콘 + 색상 병기.
 */

import { useSyncExternalStore } from 'react';
import type { UseDomainAvailabilityState } from '../../../hooks/useDomainAvailability';
import {
  tOnb, getOnboardingLang, subscribeOnboardingLang,
  type OnboardingI18nKey,
} from '../../../lib/onboarding-i18n';

const STATUS_META: Record<
  UseDomainAvailabilityState['status'],
  { color: string; icon: string; messageKey: OnboardingI18nKey }
> = {
  idle: {
    color: 'var(--color-text-secondary, #6b7280)',
    icon: '·',
    messageKey: 'onboarding.indicator.idle',
  },
  checking: {
    color: 'var(--color-text-secondary, #6b7280)',
    icon: '⏳',
    messageKey: 'onboarding.indicator.checking',
  },
  available: {
    color: 'var(--color-success, #15803d)',
    icon: '✓',
    messageKey: 'onboarding.indicator.available',
  },
  duplicate: {
    color: 'var(--color-danger, #b91c1c)',
    icon: '✕',
    messageKey: 'onboarding.indicator.duplicate',
  },
  public_mail: {
    color: 'var(--color-danger, #b91c1c)',
    icon: '✕',
    messageKey: 'onboarding.indicator.public_mail',
  },
  invalid: {
    color: 'var(--color-danger, #b91c1c)',
    icon: '✕',
    messageKey: 'onboarding.indicator.invalid',
  },
  error: {
    color: 'var(--color-danger, #b91c1c)',
    icon: '!',
    messageKey: 'onboarding.indicator.error',
  },
};

export function DomainAvailabilityIndicator({
  state,
}: {
  state: UseDomainAvailabilityState;
}) {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  const meta = STATUS_META[state.status];
  return (
    <p
      className="onboarding-step__hint"
      aria-live="polite"
      role="status"
      style={{ color: meta.color, display: 'flex', alignItems: 'center', gap: '0.375rem' }}
      data-status={state.status}
    >
      <span aria-hidden="true" style={{ fontWeight: 700 }}>
        {meta.icon}
      </span>
      <span>{state.message ?? tOnb(meta.messageKey)}</span>
    </p>
  );
}
